import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
let ls = new SecureLS({ isCompression: false });

import { db } from "../service/dryrun-firebase.js";

const getDefaultState = () => {

    return {
        userAnswerList: [],
        userResultList: [],

        userChoice: [],

        currentType: 0,
        selectType: 0,

        blockIndex: 0,

        materials: [],
        questions: [],
        answers: [],
        parts: [],

        audioAtm: {},

    };
};

const state = getDefaultState();

const mutations = {
    addAnswer: function(state, payload) {
        state.userAnswerList.splice(payload.index, 1, payload.value);
    },
    addResult: function(state, payload) {
        state.userResultList.splice(payload.index, 1, payload.value);
    },
    manageUserList: function(state, payload) {
        state.userAnswerList = payload;
    },
    manageResultList: function(state, payload) {
        state.userResultList = payload;
    },

    increaseBlockIndex(state) {
        state.blockIndex++;
    },
    decreaseBlockIndex(state) {
        state.blockIndex--;
    },
    increaseType(state, payload) {
        state.blockIndex = 0;
        state.currentType = payload;
        if (state.selectType <= state.currentType) {
            state.selectType = payload;
        }
    },

    manageAudio(state, payload) {
        state.audioAtm[payload.type] = state.audioAtm[payload.type] - 1;
    },

    setCurrentType(state, payload) {
        state.blockIndex = 0;
        state.currentType = payload;
    },

    resetState(state) {
        ls.clear();
        Object.assign(state, getDefaultState());
    },
    setQuestion(state, val) {
        state.questions = val;
    },
    setAnswer(state, val) {
        state.answers = val;
    },
    setMaterial(state, val) {
        state.materials = val;
    },

    setTypes(state, val) {
        state.parts = val;
    }
};

const actions = {
    addAnswer: function(context, payload) {
        context.commit("addAnswer", payload);
    },
    addResult: function(context, payload) {
        context.commit("addResult", payload);
    },
    manageUserList: function(context, payload) {
        context.commit("manageUserList", payload);
    },
    manageResultList: function(context, payload) {
        context.commit("manageResultList", payload);
    },
    setCurrentType: function(context, payload) {
        context.commit('setCurrentType', payload);
    },
    resetState({ commit }) {
        commit("resetState");


    },

    manageAudio: function(context, payload) {
        context.commit('manageAudio', payload);
    },

    increaseType: function(context, payload) {
        context.commit('increaseType', payload);
    },
    increaseBlockIndex({ commit }) {
        commit("increaseBlockIndex");
    },
    decreaseBlockIndex({ commit }) {
        commit("decreaseBlockIndex");
    },

    fetchQuestion({ commit }) {
        db.collection("E3T21_Question")
            .get()
            .then((querySnapshot) => {
                if (querySnapshot.empty) {
                    console.log("cannot find");
                } else {
                    var questionfetch = [];
                    querySnapshot.forEach((doc) => {
                        questionfetch.push({
                            id: doc.data().id,
                            question: doc.data().question,
                            type: doc.data().type,
                        });
                    });
                    questionfetch.sort(function(a, b) {
                        return a.id - b.id;
                    });

                    commit("setQuestion", questionfetch);
                }
            });
    },

    fetchAnswer({ commit }) {
        db.collection("E3T21_Answer")
            .get()
            .then((querySnapshot) => {
                if (querySnapshot.empty) {
                    console.log("cannot find");
                } else {
                    let answerfetch = [];
                    querySnapshot.forEach((doc) => {
                        answerfetch.push({
                            id: doc.data().id,
                            choices: doc.data().choices,
                        });
                    });
                    answerfetch.sort(function(a, b) {
                        return a.id - b.id;
                    });

                    commit("setAnswer", answerfetch);
                }
            });
    },
    fetchMaterial({ commit }) {
        db.collection("E3T21_Material")
            .get()
            .then((querySnapshot) => {
                if (querySnapshot.empty) {
                    console.log("cannot find");
                } else {
                    var materialfetch = [];
                    querySnapshot.forEach((doc) => {
                        materialfetch.push({
                            id: doc.data().id,
                            audioFile: doc.data().audioFile,
                            imageFile: doc.data().imageFile,
                            //instructionText: doc.data().instructionText,
                            textFile: doc.data().textFile,
                            type: doc.data().type,
                            questionID: doc.data().questionID,
                        });
                    });
                    materialfetch.sort(function(a, b) {
                        return a.id - b.id;
                    });

                    commit("setMaterial", materialfetch);
                }
            });
    },
    fetchTypes({ commit }) {
        db.collection("Type")
            .get()
            .then((querySnapshot) => {
                if (querySnapshot.empty) {
                    console.log("cannot find");
                } else {
                    let arr = [];
                    querySnapshot.forEach((doc) => {
                        arr.push({
                            id: parseInt(doc.id),
                            questionCount: doc.data().questionCount
                        });
                    });
                    arr.sort(function(a, b) {
                        return a.id - b.id;
                    });
                    commit("setTypes", arr);
                }
            });
    }
};

const getters = {

    getCurrentType: (state) => state.currentType,
    getSelectType: (state) => state.selectType,

    getBlockIndex: (state) => state.blockIndex,

    getuserChoice: state => state.userChoice,
    getuserAnswerList: (state) => state.userAnswerList,
    getuserResultList: (state) => state.userResultList,

    getAudioAtm: (state) => state.audioAtm,

    getExam(state) {

        let exam = [];
        for (let part of state.parts) {
            exam[part.id] = { id: part.id, questionCount: part.questionCount };
            exam[part.id].blocks = [];
            let partQuestions = state.questions.filter(item => item.type === part.id);
            while (partQuestions.length > 0) {
                let chunk = { questions: [], materialid: "", imageUrl: "", soundUrl: "", textFile: "", instructionFile: "", };
                for (let i = 0; i < part.questionCount; i++) {
                    if (partQuestions.length > 0) {
                        let question = partQuestions[0];
                        let questionChoices = state.answers.find(item => item.id === question.id);
                        question.choices = questionChoices.choices;
                        if (part.id !== 0 && part.id !== 1) {
                            question.choices.sort(function() {
                                return 0.5 - Math.random();
                            });
                        }
                        chunk.questions.push(question);
                        partQuestions.splice(0, 1);
                    }
                }
                let questionMaterial = state.materials.find(item => item.questionID === chunk.questions[0].id)
                chunk.materialid = questionMaterial.id;
                // chunk.instructionFile = questionMaterial.instructionText;
                chunk.imageUrl = questionMaterial.imageFile;
                chunk.soundUrl = questionMaterial.audioFile;
                chunk.textFile = questionMaterial.textFile;
                exam[part.id].blocks.push(chunk);
            }
        }
        return exam;
    }
};

let store = new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    plugins: [
        createPersistedState({
            storage: {
                getItem: (key) => {
                    if (ls.getAllKeys().includes(key)) {
                        return ls.get(key);
                    }
                    return null;
                },
                setItem: (key, value) => ls.set(key, value),
                removeItem: (key) => ls.remove(key),
            },
            overwrite: true,
        }),
    ],
});



export default store;